<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="repairRegistrations/cs"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @select="selectHandle"
        @reset="resetHandle">
      <template slot="otherBtn">
        <el-button type="primary" :disabled="!selection.length" @click="printHandle('/returnMerchandiseDeliveryNotePrint')"> 返厂维修打印 </el-button>
        <el-button type="primary" :disabled="!selection.length" @click="printHandle('/productRepairListPrint')"> 产品送修打印 </el-button>
        <el-button type="primary" :disabled="!selection.length" @click="printHandle('/repairRegistrationPrint')"> 报价清单打印 </el-button>
        <el-button type="primary" :disabled="!selection.length" @click="batchUpdate"> 批量修改 </el-button>
        <!--        <el-button type="primary" @click="batchReceive"> 批量发运（扫码）</el-button>-->
        <el-button type="primary" :disabled="!selection.length" @click="batchDeliver"> 批量发运</el-button>
        <el-button type="primary" :disabled="!selection.length" @click="batchGetSnByWX"> 批量条码生成 </el-button>
        <el-button v-if="limits.exportAuth" type="primary" :loading="exportLoading" @click="exportHandle">明细导出</el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="条形码">
            <el-input v-model.trim="filter.barcode" placeholder="请输入条形码" clearable/>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="filter.status" clearable placeholder="请选择状态">
              <el-option label="已接机" :value="-1"/>
              <el-option label="待签收" :value="0"/>
              <el-option label="已签收" :value="1"/>
              <el-option label="已修" :value="2"/>
              <el-option label="技术分析" :value="3"/>
              <el-option label="分析" :value="5"/>
              <el-option label="报废" :value="4"/>
              <el-option label="退货" :value="6"/>
              <el-option label="已寄回" :value="7"/>
            </el-select>
          </el-form-item>
          <el-form-item label="接机编号">
            <el-input v-model.trim="filter.masterBillNo" placeholder="请输入编号" clearable/>
          </el-form-item>
          <el-form-item label="维修编号">
            <el-input v-model.trim="filter.billNo" placeholder="请输入编号" clearable/>
          </el-form-item>
          <el-form-item label="物料号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入物料号" clearable/>
          </el-form-item>
          <el-form-item label="规格型号">
            <el-input v-model.trim="filter.specification" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="客户名称">
            <el-input v-model.trim="filter.customerName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="终端客户">
            <el-input v-model.trim="filter.terminalCustomerName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="维修人">
            <el-input v-model.trim="filter.repairName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="返厂快递单号">
            <el-input v-model.trim="filter.returnCourierNO" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="客户联系人">
            <el-input v-model.trim="filter.consignee" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="客户联系方式">
            <el-input v-model.trim="filter.consigneeContact" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="维修时间">
            <el-date-picker
                v-model="repairTimeRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('repairTimeRange', 'repairTimeStartTime', 'repairTimeEndTime')"/>
          </el-form-item>
          <el-form-item label="结款方式">
            <el-select v-model="filter.paymentMethod" clearable placeholder="请选择状态">
              <el-option label="款到发货" value="款到发货"/>
              <el-option label="月结" value="月结"/>
              <el-option label="季度结" value="季度结"/>
              <el-option label="年结" value="年结"/>
            </el-select>
          </el-form-item>
          <el-form-item label="老条形码">
            <el-input v-model.trim="filter.oldBarcode" placeholder="请输入老条形码" clearable/>
          </el-form-item>
          <el-form-item label="接机时间">
            <el-date-picker
                v-model="receiveTimeRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('receiveTimeRange', 'receiveTimeBegin', 'receiveTimeEnd')"/>
          </el-form-item>
        </el-form>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button
            type="primary"
            :loading="submitLoading"
            @click="addSalesOrder(scope.row.pkid)">
          转销单
        </el-button>
        <el-button
            type="primary"
            :loading="submitLoading"
            @click="pricePrint(scope.row)">
          报价单打印(EXCEL)
        </el-button>
      </template>
    </viewTable>
    <repair-registration-edit ref="repairRegistrationEdit" @save-success="loadData"/>
    <batch-update ref="batchUpdate" @save-success="loadData"/>
    <el-dialog
        title="批量发运（扫码）"
        :visible.sync="batchReceiveVisible"
        :close-on-click-modal="false"
        width="600px"
        @close="resetBatchReceive">
      <el-form :model="batchReceiveForm" label-width="100px">
        <el-form-item label="条形码">
          <el-input
              v-model="batchReceiveForm.barcode"
              placeholder="请输入条形码"
              clearable
              @keyup.enter.native="addBarcode">
            <el-button
                slot="append"
                icon="el-icon-check"
                type="primary"
                @click="addBarcode"/>
          </el-input>
        </el-form-item>
      </el-form>
      <div v-if="barcodeList.length > 0" class="barcode-list">
        <div class="barcode-list-title">条形码列表</div>
        <div class="barcode-items">
          <el-tag
              v-for="(barcode, index) in barcodeList"
              :key="index"
              closable
              class="barcode-item"
              @close="removeBarcode(index)">
            {{barcode}}
          </el-tag>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetBatchReceive">取消</el-button>
        <el-button type="primary" @click="confirmBatchReceive">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import RepairRegistrationEdit from "@/views/maintenanceManage/repairRegistrationCS/RepairRegistrationCSEdit";
  import BatchUpdate from "@/views/maintenanceManage/repairRegistrationCS/BatchUpdate";

  export default {
    name: "RepairRegistrationList",
    components: {BatchUpdate,RepairRegistrationEdit, viewTable},
    data() {
      return {
        limits: {
          addAuth: this.$auth(596),
          editAuth: this.$auth(597),
          delAuth: this.$auth(599),
          subAuth: this.$auth(598),
          changeAuth: this.$auth(610),
          exportAuth: this.$auth(590),
        },
        submitLoading: false,
        exportLoading: false,
        repairTimeRange: [],
        receiveTimeRange: [],
        pickerOptions: {
          shortcuts: [{
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          }],
        },
        selection: [],
        createTime: "",
        filter: {
          billNo: "",
          masterBillNo: "",
          repairName: "",
          returnCourierNO: "",
          materialNo: "",
          materialName: "",
          barcode: "",
          oldBarcode: "",
          beginCreateTime: "",
          endCreateTime: "",
          factoryNo: "",
          salesmanName: "",
          customerName: "",
          creatorName: "",
          specification: "",
          paymentMethod: "",
          serviceAddress: "",
          contact: "",
          siteMobile: "",
          status: 1,
          type: 10,
          receiveTimeBegin: "",
          receiveTimeEnd: "",
          repairTimeStartTime: "",
          repairTimeEndTime: "",
        },
        // 批量发运相关数据
        batchReceiveVisible: false,
        batchReceiveForm: {
          barcode: "",
        },
        barcodeList: [],
        columnsProperty: [
          {
            tooltip: true,
            key: "billNo",
            align: "center",
            width: 160,
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        path: "/RepairRegistrationCSPreview",
                        query: {
                          billId: params.row.pkid,
                          $tabName: params.row.billNo,
                        },
                      });
                    },
                  },
                },
                params.row.billNo,
              );
            },
          },
          {
            tooltip: true,
            key: "statusName",
            align: "center",
            width: 120,
          },
          {
            tooltip: true,
            key: "customerName",
            align: "center",
            width: 180,
          },
          {
            tooltip: true,
            key: "materialNo",
            align: "center",
            width: 120,
          },
          {
            tooltip: true,
            key: "materialName",
            align: "center",
            width: 220,
          },
          {
            tooltip: true,
            key: "typeName",
            align: "center",
            width: 120,
          },
          {
            tooltip: true,
            key: "receiveName",
            align: "center",
            width: 160,
          },
          {
            tooltip: true,
            key: "repairName",
            align: "center",
            width: 160,
          },
          {
            tooltip: true,
            key: "barcode",
            align: "center",
            width: 160,
          },
          {
            tooltip: true,
            key: "receiveTime",
            align: "center",
            width: 160,
          },
          {
            tooltip: true,
            key: "hardwareVersion",
            align: "center",
            width: 160,
          },
          {
            tooltip: true,
            key: "softwareVersion",
            align: "center",
            width: 160,
          },
          {
            tooltip: true,
            key: "historicalAlarms",
            align: "center",
            width: 160,
          },
          {
            tooltip: true,
            key: "faultReporting",
            align: "center",
            width: 160,
          },
          {
            tooltip: true,
            key: "faultActual",
            align: "center",
            width: 160,
          },
          {
            key: "action",
            align: "center",
            width: 200,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      addEditHandle(row) {
        this.$refs.repairRegistrationEdit.open(row);
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      batchDeliver() {
        let ids = [];
        this.selection.forEach(item => {
          ids.push(item.pkid);
        });
        this.$confirm("确定发运吗?", "提示", { type: "warning" }).then(() => {
          this.$http.put("basic", "repairRegistrations/batchDeliver", ids).then((resp) => {
            if (resp.success) {
              this.$message.success("操作成功");
              this.selection = [];
              this.loadData();
            }
          });
        });

      },
      submitHandle(row) {
        this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
          this.submitLoading = true;
          this.$http.get("basic", `replacementBills/submitOA/${row.pkid}`).then((resp) => {
            if (resp.success) {
              this.$message.success("提交成功");
              this.submitLoading = false;
              this.loadData();
            } else {
              this.submitLoading = false;
            }
          }).catch(() => {
            this.submitLoading = false;
          },
          );
        });
      },
      createTimeChange(date) {
        if (date !== null) {
          this.filter.beginCreateTime = date[0];
          this.filter.endCreateTime = date[1];
        } else {
          this.filter.beginCreateTime = "";
          this.filter.endCreateTime = "";
        }
      },
      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },
      batchUpdate() {
        let ids = [];
        this.selection.forEach(item => {
          ids.push(item.pkid);
        });
        this.$refs.batchUpdate.open(ids);
      },
      batchGetSnByWX() {
        let ids = [];
        this.selection.forEach(item => {
          ids.push(item.pkid);
        });
        if (this.filter.masterBillNo) {
          console.log(this.filter.masterBillNo);
          this.$confirm("确定生成条吗?", "提示", {type: "warning"}).then(() => {
            this.$http.post("basic", "repairRegistrations/getSnByWX", ids).then((resp) => {
              if (resp.success) {
                this.loadData();
                this.$message.success("生成条码成功！！！");
              }
            });
          });
        }else {
          this.$message.error("请输入接机编号！！！");
        }
      
      },
      addSalesOrder(pkid) {
        this.$confirm("确定转销售订单吗?", "提示", {type: "warning"}).then(() => {
          this.submitLoading = true;
          this.$http.get("basic", `repairRegistrations/addSalesOrder/${pkid}`).then((resp) => {
            if (resp.success) {
              this.$message.success("操作成功！");
              this.submitLoading = false;
              this.loadData();
            } else {
              this.submitLoading = false;
            }
          }).catch(() => {
            this.submitLoading = false;
          },
          );
        });
      },
      pricePrint(row) {
        this.submitLoading = true;
        this.$http.exportFile("basic",`repairRegistrations/pricePrint/${row.pkid}`).then(res => {
          let blob = new Blob([res.data]);
          let fileName = row.billNo;
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            let a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = fileName+".xls";
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
          }
          this.submitLoading = false;
        }).catch(()=>{
          this.submitLoading = false;
        });
      },

      // 打印
      printHandle(path) {
        // 返修品发货单
        const routeUrl = this.$router.resolve({
          path: path,
          query: {
            params: JSON.stringify(this.selection.map((item) => item.pkid)),
          },
        });
        window.open(routeUrl.href, "_blank");
      },
      deleteHandle(row) {
        this.$http.delete("basic", "repairRegistrations", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
      selectHandle(selection) {
        this.selection = selection;
      },

      resetHandle(filter) {
        this.filter = filter;
      },

      otherAuth(row) {
        return row.status <1;
      },
      // 批量发运相关方法
      batchReceive() {
        this.batchReceiveVisible = true;
      },
      addBarcode() {
        let barcode = this.batchReceiveForm.barcode.trim();
        if (barcode) {
          // 处理特定格式的条形码：以《*!开头且包含FSerialNum
          if (barcode.startsWith("《*！") && barcode.includes("FSerialNum：")) {
            // 正则表达式：匹配FSerialNum：后面到FAuxQty之前的内容
            const match = barcode.match(/FSerialNum：([\s\S]*?)FAuxQty/);
            if (match && match[1]) {
              barcode = match[1].trim().replace("|","");
            }
          }else if(barcode.startsWith("<*!") && barcode.includes("FSerialNum:")) {
            // 正则表达式：匹配FSerialNum：后面到FAuxQty之前的内容
            const match = barcode.match(/FSerialNum:([\s\S]*?)FAuxQty/);
            if (match && match[1]) {
              barcode = match[1].trim().replace("|","");
            }
          }
          // 处理包含2个'-'的条形码：截取两个'-'中间的字符串
          else if ((barcode.match(/-/g) || []).length === 2) {
            // 正则表达式：匹配两个'-'中间的内容
            const match = barcode.match(/-(.*?)-/);
            if (match && match[1]) {
              barcode = match[1].trim();
            }
          }
          // 处理包含3个'-'的条形码：截取第二个'-'和第三个'-'中间的字符串
          else if ((barcode.match(/-/g) || []).length === 3) {
            // 使用字符串分割方法：先分割成数组，再取第2个元素
            const parts = barcode.split("-");
            if (parts.length === 4) {
              barcode = parts[2].trim();
            }
          }
          // 处理包含4个':'的条形码：截取第三个':'和第四个':'中间的字符串
          else if ((barcode.match(/:/g) || []).length === 4) {
            // 使用字符串分割方法：先分割成数组，再取第3个元素
            const parts = barcode.split(":");
            if (parts.length === 5) {
              barcode = parts[3].trim();
            }
          }

          if (!this.barcodeList.includes(barcode)) {
            this.barcodeList.push(barcode);
            this.batchReceiveForm.barcode = "";
          } else {
            this.$message.warning("该条形码已存在");
          }
        }
      },
      removeBarcode(index) {
        this.barcodeList.splice(index, 1);
      },
      resetBatchReceive() {
        this.batchReceiveVisible = false;
        this.batchReceiveForm.barcode = "";
        this.barcodeList = [];
      },
      confirmBatchReceive() {
        // 先检查输入框中是否有未添加的条形码
        if (this.batchReceiveForm.barcode.trim()) {
          this.addBarcode();
        }
        if (this.barcodeList.length === 0) {
          this.$message.warning("请至少输入一个条形码");
          return;
        }
        this.submitLoading = true;
        // 这里可以添加批量发运的逻辑，例如调用API
        this.$http.post("basic", "repairRegistrations/batchDeliveryByBarcode", this.barcodeList).then((resp) => {
          if (resp.success) {
            this.$message.success("批量发运成功");
            this.submitLoading = false;
            this.resetBatchReceive();
            this.loadData();
          }else{
            this.submitLoading = false;
          }
        }).catch(() => {
          this.$message.error("批量发运失败");
          this.submitLoading = false;
        });
      },
      exportHandle() {
        this.exportLoading = true;
        let params = Object.assign({}, this.filter);
        this.$http.exportExcel("basic", "repairRegistrations/exportCS", params)
          .then((res) => {
            const blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            // 创建下载链接
            const link = document.createElement("a");
            const url = window.URL.createObjectURL(blob);
            // 设置下载文件名
            const fileName = `售后维修明细_${new Date().toLocaleDateString().replace(/\//g, "-")}.xlsx`;
            link.href = url;
            link.download = fileName;
            // 触发下载
            document.body.appendChild(link);
            link.click();
            // 清理
            setTimeout(() => {
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }, 100);

            this.$message.success("导出成功");
          })
          .catch(() => {
            this.exportLoading = false;
            this.$message.error("导出失败");
          })
          .finally(() => {
            this.exportLoading = false;
          });
      },

    },
  };
</script>

<style scoped>
.barcode-list {
  margin-top: 20px;
}

.barcode-list-title {
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
}

.barcode-items {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  max-height: 200px;
  overflow-y: auto;
  padding: 10px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  background-color: #f9f9f9;
}

.barcode-item {
  margin-bottom: 5px;
}
</style>
